<script lang="ts">
	import { readDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Hooks
	import { onMount } from 'svelte';
	//Services
	import { format } from 'svelte-i18n';
	import { postReq } from 'src/services/http';
	//Stores
	//Helpers
	import { real_id, real_id_z } from 'src/helpers/interface_helpers';
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	//Types
	import type { SettingRequest } from 'src/types/requests/settings/setting';
	//Design system components
	import { Button, Radio, Text } from '@Shelly/shelly-design-system';

	export let device;

	const id = real_id(device.id);

	const inputOptions = ['stored', 'not_stored'];
	const _input_options_i18n = [
		$format('stored_default', { default: 'Stored last state' }),
		$format('not_stored_default', { default: 'Not Stored last state' }),
	];

	let settings = readDeviceSettings(id),
		inputTypes = {},
		deviceChannel = device.channel,
		setting = deviceChannel === 0 ? 17 : 18,
		loading = false,
		cache;

	onMount(() => {
		inputTypes[deviceChannel] = settings[`Configuration:0`][setting];
		cache = Object.assign({}, { ...inputTypes });
	});

	const setInputType = (value) => {
		inputTypes[deviceChannel] = value;
	};
	const sentRequest = async () => {
		if (JSON.stringify(cache) !== JSON.stringify(inputTypes)) {
			let isok = false;
			loading = true;

			const params = {
				id: real_id_z(device.id), //gateway's id
				a: 'call', //inclusion command
				cc: 'Configuration', //command class
				m: 'set', //method
				ep: 0, //endpoint
				params: JSON.stringify([{ parameter: setting, value: +inputTypes[deviceChannel] }]), //parameters parameter - setting index, value - setting value
			};
			const res: SettingRequest = await postReq(`/fast/device/zw`, {
				...params,
			});

			if (res.isok) {
				params.m = 'get'; //override method
				params.params = JSON.stringify([+setting]); //override params
				const res_get: SettingRequest = await postReq(`/fast/device/zw`, {
					...params,
				});
			}
			await onSettingsResponse(res, device);
			loading = false;
		}
	};
</script>

<Text element="h2" styleType="h2" class="mb-s">
	{$format('input_type_desc', { default: 'Set input type' })}
</Text>

{#each inputOptions as option, index}
	<Radio
		size="m"
		selected={inputOptions[inputTypes[deviceChannel]]}
		value={option}
		on:click={() => setInputType(index)}
		id="radio-i1px3rn"
	>
		{_input_options_i18n[index]}
	</Radio>
{/each}

<Button class="mt-s" {loading} size="m" width="full" on:click={sentRequest}>
	{$format('button_save')}
</Button>
